import type { DropEvent } from "react-aria";
import {
  type FileDropItem,
  isFileDropItem,
  DropZone as RACDropZone,
  type DropZoneProps as RACDropZoneProps,
  FileTrigger as RACFileTrigger,
  type FileTriggerProps as RACFileTriggerProps,
} from "react-aria-components";

export type { DropEvent, FileDropItem };
export { isFileDropItem };

export interface DropZoneProps extends RACDropZoneProps {}
export interface FileTriggerProps extends RACFileTriggerProps {}

export function DropZone(props: DropZoneProps) {
  return <RACDropZone {...props} />;
}

export function FileTrigger(props: FileTriggerProps) {
  return <RACFileTrigger {...props} />;
}
